import { AdminState } from './types'

export const state: AdminState = {
  loadingAdmin: true,
  periods: [],
  adminDetail: {
    doctorId: 0,
    doctorPeriodPaymentId: 0,
    paymentLink: '',
    totalEarnedInPeriod: 0,
    consultationCount: 0,
    commissionTotal: 0,
    doctorPayStatus: 0,
    doctorPayStatusText: '',
    amountGenerated: 0,
    lumineDoctorRank: 0
  }
}
